import { Portal } from '@radix-ui/react-portal'

import { toastsContainerId } from 'lib/constants/ids'
import { useGetToasts } from 'store/toasts.state'

import Box from 'components/atomic/atoms/box'
import { Toast } from 'components/pages/@shared/toasts/toast'

const Toasts = () => {
  const toasts = useGetToasts()

  if (!toasts?.length) {
    return null
  }

  return (
    <Portal id={toastsContainerId} style={{ pointerEvents: 'none' }}>
      <Box
        fixed
        css={{
          zIndex: 10,
          pointerEvents: 'auto',
          bottom: '$7',
          right: '$7',
        }}
      >
        <Box grid css={{ gap: '$3' }}>
          {toasts.map(toastProps => (
            <Toast key={toastProps.id} {...toastProps} />
          ))}
        </Box>
      </Box>
    </Portal>
  )
}

export default Toasts
